<template>
  <v-row justify="center">
    <v-col lg="6" md="8" xl="4">
      <v-card>
        <v-form @submit.prevent="save" ref="editForm">
          <v-card-title>
            <h2>{{ $t("admin.team.settings.branding.title") }}</h2>
          </v-card-title>
          <v-card-text>
            <v-img :src="team.brandingLogoUrl || ''" contain max-height="200"></v-img>
            <template>
              <v-file-input accept="image/*" label="Logo" v-model="file"></v-file-input>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit">
              {{ $t("admin.team.settings.branding.save") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "settings.branding",
  data() {
    return {
      team: {},
      menuMainColor: null,
      menuTextColor: null,
      menuBackgroundColor: null,
      file: null,
    };
  },
  mounted() {
    this.getTeamFromApi();
  },
  methods: {
    async getTeamFromApi() {
      this.loading = true;
      this.team = await axios.get(`/event/teams/${this.$route.params.teamId}`);
      this.loading = false;
    },
    async save() {
      if (this.file) {
        let formData = new FormData();
        formData.append("file", this.file);
        const axiosResponse = await axios.post("/files", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        this.team.brandingLogoUrl = axiosResponse.serveURL;
      }

      await axios.put(`/admin/teams/${this.$route.params.teamId}`, this.team);

      this.$store.commit("SUCCESS", this.$t("admin.team.settings.branding.msgSaved"));
    },
  },
};
</script>

<style scoped></style>
